import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { ImExit } from 'react-icons/im';
import {
  getSidebarsForRole,
  RoleName,
  SidebarItem,
} from '../../services/SidebarService';

interface SidebarContentProps {
  onItemClick?: () => void;
}

const SidebarContent: React.FC<SidebarContentProps> = ({ onItemClick }) => {
  const cookies = new Cookies(null, { path: '/' });
  const navigate = useNavigate();
  const location = useLocation();

  const roleName = cookies.get('role_name') as RoleName | undefined;
  const allowedSidebars = getSidebarsForRole(roleName ?? null);

  const onLogout = () => {
    cookies.remove('token');
    cookies.remove('user_id');
    cookies.remove('role_name');
    cookies.remove('role_label');
    navigate('/login');
  };

  return (
    <div className="h-full flex flex-col justify-between bg-[#161b2e] text-white p-4">
      <div className="space-y-1">
        <div className="py-4 text-center border-b border-white/10 mb-4">
          <span className="text-cyan-400 font-black text-lg tracking-wider">
            TIDACO PANEL
          </span>
        </div>

        {allowedSidebars.map((item: SidebarItem) => {
          // بررسی دقیق اکتیو بودن منو بر اساس مسیر جاری
          const isActive =
            item.url === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.url);

          const Icon = item.icon;

          return (
            <li key={item.name} className="list-none">
              <Link
                to={item.url}
                onClick={onItemClick}
                className={`flex items-center gap-3 rounded-xl px-4 py-3 transition-all duration-200 ${
                  isActive
                    ? 'bg-cyan-600 text-white shadow-lg shadow-cyan-600/20'
                    : 'text-gray-400 hover:bg-white/5 hover:text-white'
                }`}
              >
                <span
                  className={`grid h-8 w-8 place-items-center rounded-lg transition-colors ${
                    isActive
                      ? 'bg-white text-[#161b2e]'
                      : 'bg-white/10 text-white'
                  }`}
                >
                  <Icon size={18} />
                </span>
                <span className="text-sm font-medium">{item.title}</span>
              </Link>
            </li>
          );
        })}
      </div>

      <div className="mt-auto pt-4 border-t border-white/10">
        <button
          type="button"
          onClick={onLogout}
          className="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-all duration-200"
        >
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-red-500/10 text-red-400">
            <ImExit size={18} />
          </span>
          <span className="text-sm font-semibold">خروج از حساب</span>
        </button>
      </div>
    </div>
  );
};

export default SidebarContent;
